import { isMobileOrTablet } from './src-utils-mobile-utils.js';

const handleProductPages = (pageName) => {
  const caStoredPlacement = localStorage.getItem("caBottomPlacement");
  const caButton = document.getElementById("caHelpButton");
  if (pageName && pageName?.toLowerCase().includes("product page") && isMobileOrTablet() && caStoredPlacement && caButton != null) {
    caButton.style.marginBottom = caStoredPlacement;
    localStorage.removeItem("caBottomPlacement");
  }
};

export { handleProductPages };
//# sourceMappingURL=src-utils-chat-product-page-utils.js.map
